import { render, staticRenderFns } from "./ChatMessageEditButtons.vue?vue&type=template&id=9c24b1de"
import script from "./ChatMessageEditButtons.vue?vue&type=script&lang=ts"
export * from "./ChatMessageEditButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports